const getUnitTheme = () => ({
    visible: !1,
    style: {
        fontSize: {
            type: "token",
            key: "l5FontSize"
        },
        fill: {
            type: "palette",
            key: "axisLabelFontColor"
        },
        fontWeight: "normal",
        fillOpacity: 1
    }
});

export const axisX = {
    label: {
        space: 8
    },
    title: {
        space: 8
    },
    maxHeight: "30%",
    unit: {
        visible: !1,
        style: {
            fontSize: {
                type: "token",
                key: "l5FontSize"
            },
            fill: {
                type: "palette",
                key: "axisLabelFontColor"
            },
            fontWeight: "normal",
            fillOpacity: 1
        }
    }
};

export const axisY = {
    label: {
        space: 12,
        autoLimit: !0
    },
    title: {
        space: 12,
        autoRotate: !0
    },
    maxWidth: "30%",
    unit: {
        visible: !1,
        style: {
            fontSize: {
                type: "token",
                key: "l5FontSize"
            },
            fill: {
                type: "palette",
                key: "axisLabelFontColor"
            },
            fontWeight: "normal",
            fillOpacity: 1
        }
    }
};
//# sourceMappingURL=cartesian-axis.js.map
